import classnames from 'classnames';
import React from 'react';
import './NavigationButton.scss';

export const NavigationButton: React.FC<{
    ariaLabel?: string;
    disabled?: boolean;
    icon: JSX.Element;
    className?: string;
    onClick: () => void;
}> = ({ disabled, icon, onClick, ariaLabel, children, className }) => (
    <button
        disabled={disabled}
        type="button"
        onClick={onClick}
        className={classnames('navigation-button animation-fade-in', className)}
        aria-label={ariaLabel}
    >
        <div className="navigation-icon">{icon}</div>
        {children}
    </button>
);
